export default {
  setCategories: (state, payload) => {
    state.categories = payload;
  },
  setSubcategories: (state, payload) => {
    state.subcategories = payload;
  },
};
